module.exports = __webpack_public_path__ + "img/USDT.a440d4b5.png";